import React from 'react';
import { Icon } from 'antd';
import styled from 'styled-components';
import { WhiteFour, DarkishBlue } from '../../styles/Colours';
import { Container } from '../../styles/BaseStyles';
import cookie from 'react-cookies';

const CookiesSection = styled.div`
  background: ${DarkishBlue};
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 40px;
`;

const Info = styled.div`
  color: ${WhiteFour};
  float: left;
  font-size: 16px;
  a{
    color: ${WhiteFour}
    text-decoration: underline;
    &:hover, &:active, &:focus{
      color: ${WhiteFour}
      text-decoration: underline;
    }
  }
`;

const Link = styled.div`
  color: ${WhiteFour};
  font-size: 16px;
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  i {
    margin-left: 20px;
    font-size: 30px;
  }
`;

class CookiesPopup extends React.Component {
  state = {
    accepted: cookie.load('cookie_policy')
  };

  saveCookie = () => {
    this.setState({ accepted: true }, () =>
      cookie.save('cookie_policy', 'accepted')
    );
  };

  render() {
    const { accepted } = this.state;
    const { history } = this.props;
    if (!accepted) {
      return (
        <CookiesSection>
          <Container>
            <Info>
              We use cookies to improve your browsing experience and for
              statistical purposes.&nbsp;<Link onClick={() => history.push('/cookies')}><a>Know more</a></Link>
            </Info>
            <Link onClick={this.saveCookie}>
              Accept
              <Icon type="arrow-right" theme="outlined" />
            </Link>
          </Container>
        </CookiesSection>
      );
    }
    return null;
  }
}
export default CookiesPopup;



// WEBPACK FOOTER //
// ./src/pages/layout/CookiesPopup.js